import API from "@/services/api";

export default{
    addCluster(params){
        return API().post(`cluster`,params);
    },
    updateCluster(id,params){
        return API().put(`cluster/${id}`,params);
    },
    deleteCluster(id){
        return API().get(`cluster/delete/${id}`);
    }
}